<template>
  <v-reports
    v-bind:headers="headers"
    v-bind:update="update"
    v-bind:data="data"
    invValuation
    v-bind:num-pages="total"
    v-model="page"
    @change-pagination="changePagination"
    :data_loading="data_loading"
    :row="invSupVal"
    inv
  >
    <template #top>
      <v-flex class="px-2 my-auto mb-10 mt-4" md12>
        <!--<v-combobox-->
        <!--v-model="supplier"-->
        <!--v-bind:items="main_all_suppliers_"-->
        <!--item-text="supplier_name"-->
        <!--solo-->
        <!--dense-->
        <!--prepend-inner-icon="mdi-account"-->
        <!--/>-->
        <!-- <p>{{ limitTest }}</p> -->

        <v-card>
          <v-row>
            <v-col>
              <v-btn text @click="goBack">
                <v-icon>mdi-arrow-left</v-icon>
                Supplier Valuation
              </v-btn>
            </v-col>
          </v-row>
          <v-row class="mt-n6">
            <v-col>
              <v-card-text class="font-weight-bold">
                Supplier name:
                <span class="font-weight-regular">{{
                  $store.state.main_supplier.name
                }}</span>
              </v-card-text>
            </v-col>
            <v-col>
              <v-card-text class="font-weight-bold">
                Store name:
                <span class="font-weight-regular">{{
                  $store.state.main_store.name
                    ? $store.state.main_store.name
                    : "All stores"
                }}</span>
              </v-card-text>
            </v-col>
          </v-row>
        </v-card>
      </v-flex>
    </template>
    <template #search_text>
      <v-btn icon @click="downloadExcel">
        <v-icon>mdi-download</v-icon>
      </v-btn>
      <v-dialog v-model="exceldialog" max-width="500px">
        <v-card>
          <v-card-title v-if="excelwait">Iltimos kutib turing!</v-card-title>
          <v-card-title v-else>Excel yuklashga tayyor</v-card-title>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              text
              color="primary"
              @click="saveExcel"
              :disabled="excelwait"
            >
              <export-excel :data="dovnExcel" :name="excel_name">
                Save Excel
              </export-excel>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <template #header>
      <v-card>
        <v-card-text>
          <v-layout row>
            <v-flex md3 sm6 xs12 px-3>
              <div>{{ $t("total_inventory_value") }}</div>
              <p class="display-1 text--primary text-center">{{ inventory }}</p>
            </v-flex>
            <v-flex md3 sm6 xs12 px-3>
              <div>{{ $t("total_retail_value") }}</div>
              <p class="display-1 text--primary text-center">{{ retail }}</p>
            </v-flex>
            <v-flex md3 sm6 xs12 px-3>
              <div>{{ $t("potential_profit") }}</div>
              <p class="display-1 text--primary text-center">{{ potential }}</p>
            </v-flex>
            <v-flex md3 sm6 xs12 px-3>
              <div>{{ $t("margin") }}</div>
              <p class="display-1 text--primary text-center">{{ margin }} %</p>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </template>
  </v-reports>
</template>
<script>
import Suppliers from "../../mixins/inventory/supplier";
import Currency from "../../mixins/settings/currency";
// import Loading from "../../components/VLoading/Loading.vue";
const AllSuppliers = Object.assign(
  { ...Suppliers },
  {
    mounted() {
      this.get_all_suppliers();
    },
  }
);
export default {
  loading: false,
  name: "InventorySupplierValuation",
  mixins: [AllSuppliers, Currency],
  data: () => ({
    headers: [
      { text: "Item", value: "inv_name", available: true, disabled: true },
      { text: "In stock", value: "in_stock", available: true },
      { text: "Cost", value: "cost", available: true },
      { text: "Inventory value", value: "inventory", available: true },
      { text: "Retail value", value: "retail", available: true },
      { text: "Potential profit", value: "potential", available: true },
      { text: "Margin", value: "margin", available: true },
    ],
    excelwait: true,
    dovnExcel: [],
    limit_stock: "",
    excel_name: "History Excel Export",
    data: [],
    exceldialog: false,
    params: {},
    data_loading: false,
    page: 1,
    total: 0,
    inventory: 0,
    valuation: [],
    retail: 0,
    potential: 0,
    margin: 0,
    to: "/items/list",
  }),
  watch: {
    // limitTest() {
    //   return this.test;
    // },
    supplier() {
      this.update(this.params);
    },
    page() {
      this.update(this.params);
    },
  },
  methods: {
    saveExcel() {
      this.exceldialog = false;
      this.excelwait = true;
    },
    link(target) {
      if (target == "create") {
        return this.to + "/create";
      }
      if (target == "update") {
        if (this.view) return this.to + "/view";
        return this.to + "/update";
      }
      return this.to;
    },
    invSupVal(item) {
      this.$router.push({
        path: this.link("update"),
        query: { id: item._id },
      });
    },
    goBack() {
      // this.$router.push('/inventory/supplier/valuation')
      this.$router.back();
    },
    async downloadExcel() {
      this.loading = true;
      this.exceldialog = true;
      const link = `inventory/valuation`;
      const res = await this.$communicator.postMethod(link, {
        limit: 999999999,
        page: 1,
        service: this.params.service ? this.params.service : "",
        supplier_id: this.$store.state.main_supplier._id,
        project: {
          _id: 0,
          name: 1,
          has_variants: 0,
          item_type: 0,
          barcode: 1,
          sku: 1,
          variant_items: 0,
          cost: 1,
          in_stock: 1,
          retail: 0,
          potential: 0,
        },
      });
      // this.valuation = res?.data?.data?.data;
      this.dovnExcel = await res?.data?.data?.data;
      setTimeout(() => (this.excelwait = false), 3000);
    },
    changePagination(page) {
      this.page = page;
    },
    async update(params) {
      const current_currency =
        this.currency && this.currency.currency == "usd" ? 100 : 1;
      this.current_currency = current_currency;
      this.data_loading = true;
      this.params = params;
      var valuation = this.$communicator.then(
        this,
        await this.$communicator("inventory_valuation", {
          params: {
            service: this.$store.state.main_store._id ?? "",
            supplier_id: this.$store.state.main_supplier._id,
            limit: 10,
            page: this.page,
          },
        })
      );
      this.data = valuation.data;
      this.total = valuation.page;
      this.data_loading = false;
      this.inventory = (
        Math.ceil(valuation.inventory * current_currency) / current_currency
      ).toLocaleString();
      this.retail = (
        Math.ceil(valuation.retail * current_currency) / current_currency
      ).toLocaleString();
      this.potential = (
        Math.ceil(valuation.potential * current_currency) / current_currency
      ).toLocaleString();
      this.margin = Math.ceil(valuation.margin);
    },
  },
  async mounted() {
    await this.get_currency();
    this.headers = [
      {
        text: this.$t("item"),
        value: "inv_name",
        available: true,
        disabled: true,
      },
      {
        text: this.$t("in_stock"),
        value: "in_stock",
        available: true,
        width: 120,
        align: "right",
      },
      {
        text: this.$t("cost"),
        value: "cost",
        available: true,
        width: 120,
        align: "right",
      },
      {
        text: this.$t("inventory_value"),
        value: "inventory",
        available: true,
        width: 120,
        align: "right",
      },
      {
        text: this.$t("retail_value"),
        value: "retail",
        available: true,
        width: 120,
        align: "right",
      },
      {
        text: this.$t("potential_profit"),
        value: "potential",
        available: true,
        width: 120,
        align: "right",
      },
      {
        text: this.$t("margin"),
        value: "margin",
        available: true,
        width: 120,
        align: "right",
      },
    ];
    for (const index in this.headers) {
      this.headers[index]["sortable"] = false;
    }
  },
  destroyed() {
    // this.$store.state.main_supplier = {}
    // console.log(this.$store.state.main_supplier, "destroyed")
  },
  // components: {
  //   Loading,
  // },
};
</script>
